import {
    CheckBoxProps,
    CheckBoxWidget
    } from '@tableau/widgets';
import { BodyCell } from '@tableau/widgets-datagrid';
import React from 'react';

import { CheckboxState } from '~src/commonInfra/components/checkbox/CheckboxState';

import { AddGroupsToGroupSetDataKeys, AddGroupsToGroupSetTypes } from './AddGroupsToGroupSetGrid';

export const ADD_GROUPS_TO_GROUPSET_GRID_ROW_CHECKBOX_TEST_ID = 'add-groups-to-groupset-grid-row-';

export class AddGroupsToGroupSetGridCellFormatter extends React.PureComponent<BodyCell.Props, object> {
    public constructor(props: BodyCell.Props) {
      super(props);
    }

    private renderCheckboxCell(): JSX.Element {
        const checkBoxCellData = this.props.row.data[AddGroupsToGroupSetDataKeys.Select] as AddGroupsToGroupSetTypes.CheckboxCellData;
        const checkboxChecked = checkBoxCellData.checkboxState === CheckboxState.checked;
        const checkboxMixedState = checkBoxCellData.checkboxState === CheckboxState.mixed;
        const checkBoxProps: CheckBoxProps = {
          checked: checkboxChecked,
          handleChange: checkBoxCellData.onCheckboxChanged,
          indeterminate: checkboxMixedState,
          testId: ADD_GROUPS_TO_GROUPSET_GRID_ROW_CHECKBOX_TEST_ID + this.props.rowIdx,
          disabled: !checkBoxCellData.isCheckboxEnabled
        };

        return <div>
          <CheckBoxWidget {...checkBoxProps}/>
        </div>;
    }

    public render(): JSX.Element {
        const columnKey = this.props.col.dataKey as AddGroupsToGroupSetDataKeys;
        switch(columnKey) {
            case AddGroupsToGroupSetDataKeys.Select:
              return this.renderCheckboxCell();
            default:
              return <React.Fragment />;
          }
    }
}


const AddGroupsToGroupSetGridCellFormatterFactory = React.createFactory(AddGroupsToGroupSetGridCellFormatter);

export { AddGroupsToGroupSetGridCellFormatterFactory };
